export default __webpack_public_path__ + "static/media/I53.94c6cb34.jpg";